import ItemPlugin from "./Base64ImageItem/Base64ImageItem";
import { processRawInput } from "./processRawInput";
import userShare from "./userShare";

export default function registerBase64ImagePlugin() {
  return { ItemPlugin, processRawInput, userShare };
}
